export default "__VITE_ASSET__By6B9cya__"